<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="d-flex">
                <h5 class="mb-0">User Accounts</h5>
              </div>
              <div class="d-flex form-inline">
                <div class="form-group">
                  <SectionDropdown v-if="false" id="ddSectionFilter" :selected="selectedSection" @selected-section-id="
                    (selectedValue) => (selectedSection = selectedValue)
                  " />
                  <PlatoonDropdown id="ddPlatoon" :allow-all="isAdminRole" :selected="selectedPlatoon"
                    @selected-platoon-id="
                      (selectedValue) => (selectedPlatoon = selectedValue)" />
                </div>
                <div class="form-group">
                  <argon-input id="search" name="search" :value="searchText" type="text" placeholder="Search..."
                    aria-label="Search" class="ms-3" @input="(event) => (searchText = event.target.value)"
                    @keyup.enter="search()" />
                </div>

                <div class="hr vertical separator mx-3 bg-white opacity-2"></div>
                <div class="form-group">
                  <argon-button color="success" @click="modals.add = true">ADD USER</argon-button>
                </div>

                <!-- Add User Modal -->
                <UserRegistration v-if="modals.add" :is-create-mode="modals.add" :form-rules="newUserRules" />

                <!-- Edit User Modal -->
                <UserRegistration v-if="modals.edit" :form-rules="editUserRules" :selected-user="selectedUser"
                  :is-create-mode="false" />

                <!-- Reset Password Modal -->
                <modal v-if="selectedUser" id="resetPasswordModal" v-model:show="modals.reset" :show-close="true">
                  <template #header>
                    <h6 class="modal-title">Reset Password</h6>
                  </template>

                  <form class="p-2">
                    <div class="row">
                      <div class="col-12">
                        <div class="text-lighter text-bold">
                          {{ selectedUser.name }}
                        </div>
                        <div class="text-uppercase text-sm text-light">
                          {{ selectedUser.platoon ? selectedUser.platoon.name : "" }}
                          /
                          {{ selectedUser.section ? selectedUser.section.name : "" }}
                        </div>
                      </div>
                    </div>
                    <div class="row p-4">
                      <div v-for="req in passwordReqs" :key="req.name" class="col-12 text-white">
                        <div class="mt-2 text-sm">
                          <icon-check-pass v-if="req.validated" />
                          <icon-check-fail v-else />
                          <span class="ms-2">{{ req.text }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mt-3">
                        <label for="txtResetPassword">Password</label>
                        <argon-input id="txtResetPassword" :type="resetPassword.fieldType" :value="resetPassword.value"
                          icon-dir="right" :icon="resetPassword.icon" @click="togglePasswordVisibility(resetPassword)"
                          @input="
                            (event) =>
                              (resetPassword.value = event.target.value)
                          " />
                      </div>
                    </div>
                  </form>
                  <template #footer>
                    <button type="button" class="btn btn-primary" :disabled="!isPasswordReqsFulfilled()"
                      @click="reset()">
                      RESET
                    </button>
                  </template>
                </modal>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="card-body">
            <div class="table-responsive">
              <el-table ref="dataTable" :data="users" style="width: 100%" @sort-change="sortColumn">
                <el-table-column prop="name" label="Name" width="300" sortable="custom" />
                <el-table-column prop="user_id" label="User ID" width="180" sortable="custom" />
                <el-table-column prop="platoon_id" label="Platoon" width="250" sortable="custom">
                  <template #default="scope">
                    <div class="text-uppercase">
                      {{ scope.row.platoon ? scope.row.platoon.name : "-" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="section_id" label="Section" width="150" sortable="custom">
                  <template #default="scope">
                    <div class="text-uppercase">
                      {{ scope.row.section ? scope.row.section.name : "-" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="gender" label="Gender" sortable="custom" width="100px" />
                <el-table-column prop="date_of_birth" label="Date Of Birth" width="150" sortable="custom">
                  <template #default="scope">
                    <div>
                      {{ scope.row.date_of_birth ? formatDob(scope.row.date_of_birth) : "-" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="age" label="Age" sortable="custom" width="100" />
                <el-table-column prop="height_cm" label="Height" sortable="custom" width="100">
                  <template #default="scope">
                    {{ scope.row.height_cm }} cm
                  </template>
                </el-table-column>
                <el-table-column prop="weight_kg" label="Weight" sortable="custom" width="100">
                  <template #default="scope">
                    {{ scope.row.weight_kg }} kg
                  </template>
                </el-table-column>
                <el-table-column prop="email" label="Email" width="180" />
                <el-table-column prop="mobile_no" label="Phone Number" width="150" />

                <el-table-column prop="is_active" label="Active" sortable="custom" width="100">
                  <template #default="scope">
                    {{ scope.row.is_active ? "Yes" : "No" }}
                  </template>
                </el-table-column>
                <el-table-column label="Actions" width="150">
                  <template #default="scope">
                    <div class="d-flex">
                      <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit"
                        class="btn btn-link mb-0 px-0">
                        <a href="#" data-toggle="modal" data-target="#editTaskModal"
                          @click.prevent="handleEdit(scope.$index, scope.row)"><icon-edit /></a>
                      </button>
                      <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Reset password"
                        class="btn btn-link mb-0 px-0">
                        <a href="#" data-toggle="modal" data-target="#resetPasswordModal"
                          @click="handleResetPaswword(scope.$index, scope.row)"><icon-edit-password class="ms-3" /></a>
                      </button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="created_at" label="Created Date" width="150" sortable="custom">
                  <template #default="scope">
                    <div>
                      {{
                        scope.row.created_at
                          ? formatDob(scope.row.created_at)
                          : "-"
                      }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="band_name" label="Band Name" width="150">
                  <template #default="scope">
                    <div v-if="scope.row.assigned_devices.length > 0">
                      {{ scope.row.bandName }}
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="card-footer">
            <div class="d-flex justify-content-end align-items-center">
              <app-pagination :records="count" :page-size="pageSize" :page="page" @update-page-selection="
                (selectedValue) => updatePageSelection(selectedValue)
              " />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "@/helpers/constants";
import Utils from "@/helpers/utils";
import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";

import ArgonButton from "@/shared/Controls/ArgonButton.vue";
import ArgonInput from "@/shared/Controls/ArgonInput.vue";
import IconEdit from "@/shared/Controls/Icons/IconEdit.vue";
import IconEditPassword from "@/shared/Controls/Icons/IconEditPassword.vue";
import IconCheckPass from "@/shared/Controls/Icons/IconCheckPass.vue";
import IconCheckFail from "@/shared/Controls/Icons/IconCheckFail.vue";
import Modal from "@/shared/Modal.vue";

import SectionDropdown from "../../components/SectionDropdown.vue";
import PlatoonDropdown from "../../components/PlatoonDropdown.vue";
import UserRegistration from "./UserRegistration.vue";


export default {
  name: "UserAccountsTable",
  components: {
    ArgonButton,
    ArgonInput,
    IconCheckFail,
    IconCheckPass,
    IconEdit,
    IconEditPassword,
    Modal,
    SectionDropdown,
    UserRegistration,
    PlatoonDropdown,
  },
  data() {
    var validateRole = (rule, value, callback) => {
      if (value == -1) {
        return callback(new Error('Please select Role'));
      }
      callback();
    };
    var validatePlatoon = (rule, value, callback) => {
      if (value == -1) {
        return callback(new Error('Please select Platoon'));
      }
      callback();
    };
    var validateSection = (rule, value, callback) => {
      if (value == -1) {
        return callback(new Error('Please select Section'));
      }
      callback();
    };
    var validateHeight = (rule, value, callback) => {
      if (value < 50) {
        return callback(new Error('Height should be more than 50 cm'));
      }
      callback();
    };
    var validateWeight = (rule, value, callback) => {
      if (value < 20) {
        return callback(new Error('Weight should be more than 20 kg'));
      }
      callback();
    };

    return {
      users: [],
      selectedSection: -1, // filter
      searchText: "",
      page: Constants.DEFAULT_PAGE,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
      sort: "name",
      order: "asc",
      count: 0,
      name: "",
      user: {}, // add
      selectedUser: null, // edit
      defaultUser: {
        user_id: "",
        password: {
          fieldType: "password",
          value: "",
          icon: "fa fas fa-eye",
        },
        role_id: -1,
        name: "",
        platoon_id: -1,
        section_id: -1,
        gender: "M",
        date_of_birth: null,
        age: 0,
        height_cm: "",
        weight_kg: "",
        active: true,
        created_at: null,
        devices: [
          {
            serial: "",
            address: "",
          },
          {
            serial: "",
            address: "",
          },
        ],
      },
      resetPassword: {
        fieldType: "password",
        value: "",
        icon: "fa fas fa-eye",
      },
      modals: { add: false, edit: false, reset: false },
      columns: [
        "name",
        "platoon",
        "section",
        "gender",
        "date of birth",
        "age",
        "height (cm)",
        "weight (kg)",
        "activated?",
        "actions",
        "created_at",
      ],
      passwordReqs: [
        {
          name: "charLen",
          text: "At least 8 characters",
          validated: false,
        },
        {
          name: "uppercase",
          text: "At least 1 uppercase character",
          validated: false,
        },
        {
          name: "lowercase",
          text: "At least 1 lowercase character",
          validated: false,
        },
        {
          name: "special",
          text: "At least 1 special character (eg. !@#$%)",
          validated: false,
        },
        {
          name: "digit",
          text: "At least 1 digit",
          validated: false,
        },
      ],
      addingUser: false,
      loggedInUser: null,
      selectedPlatoon: -1, // filter
      editUserRules: {
        user_id: [
          { required: true, message: 'User Id is required', trigger: 'blur' },
          { min: 5, message: 'User Id must be at least 5 characters', trigger: 'blur' }
        ],
        role_id: [
          { required: true, message: 'Role is required', trigger: 'change' },
          { validator: validateRole, trigger: 'change' }
        ],
        name: [
          { required: true, message: 'Name is required', trigger: 'blur' },
          { minLength: 3, message: 'Name must be at least 3 characters', trigger: 'blur' }
        ],
        platoon_id: [
          { required: true, message: 'Platoon is required', trigger: 'change' },
          { validator: validatePlatoon, trigger: 'change' }
        ],
        section_id: [
          { required: true, message: 'Section is required', trigger: 'change' },
          { validator: validateSection, trigger: 'change' }
        ],
        gender: [
          { required: true, message: 'Please select gender', trigger: 'change' }
        ],
        date_of_birth: [
          { required: true, message: 'Date of birth is required', trigger: ['blur', 'change'] },
        ],
        height_cm: [
          { required: true, message: 'Height is required', trigger: 'blur' },
          { validator: validateHeight, trigger: ['change', 'blur'] }
        ],
        weight_kg: [
          { required: true, message: 'Weight is required', trigger: 'blur' },
          { validator: validateWeight, trigger: ['change', 'blur'] }
        ],
      },
      newUserRules: {},
      isAdminRole: false,
    };
  },
  watch: {
    selectedSection() {
      // for filter
      this.page = 1;
      this.getUserList();
    },
    selectedPlatoon() {
      // for filter
      this.page = 1;
      this.getUserList();
    },
    searchText() {
      if (this.searchText.trim().length == 0) this.getUserList();
    },
    "resetPassword.value"(newValue) {
      this.validatePasswordReqs(newValue);
    },
  },
  created() {
    this.user = Object.assign({}, this.defaultUser);
  },
  mounted() {
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
    this.loggedInUser = this.$store.getters["auth/getLoggedInUser"]();
    if (this.loggedInUser.role && this.loggedInUser.role.role_id == Constants.ROLES.PLATOON_COMMANDER) {
      this.selectedPlatoon = this.loggedInUser.platoon_id;
    }
    if (Constants.ADMIN_USER_ROLES.includes(this.loggedInUser.role.role_id)) {
      this.isAdminRole = true;
    }
    this.newUserRules = { ...this.editUserRules };
    this.newUserRules.password = [
      { required: true, message: 'Password is required', trigger: 'blur' },
      { min: 6, message: 'Password must be at least 6 characters', trigger: 'blur' }
    ];
    this.getUserList();
  },
  methods: {
    formatDob(dob) {
      return Utils.formatDob(dob);
    },
    getUserList() {
      this.$store
        .dispatch("user/list", {
          page: this.page,
          page_size: this.pageSize,
          sort: this.sort,
          order: this.order,
          section_id: this.selectedSection || -1,
          search_term: this.searchText,
          platoon_id: this.selectedPlatoon || -1,
        })
        .then((data) => {
          const { count, rows } = data.data;
          this.count = count;
          this.users = rows;

          this.users.map((user) => {
            if (user.assigned_devices.length > 0 && user.assigned_devices[0].name) {
              let bandNames = user.assigned_devices[0].name.split(" ");
              user.bandName = 'Band '+ bandNames[bandNames.length - 1] || "-";
            } else {
              user.bandName = "-";
            }

            if (user.assigned_devices.length < 2) {
              for (let i = user.assigned_devices.length; i < 2; i++) {
                user.assigned_devices.push({ serial: "", address: ""});
              }
            }
          });
        }).catch((err) => {
          console.error("Error fetching user list: ", err);
          this.$snackbar.add({
            type: "error",
            text: "Failed to fetch user list.",
          });
        });
    },
    sortColumn({ prop, order }) {
      this.sort = prop;
      this.order = order == "ascending" ? "asc" : "desc";
      this.getUserList();
    },
    updatePageSelection(newPageIndex) {
      this.page = newPageIndex;
      this.getUserList();
    },
    animateRow(index) {
      const table = this.$refs.dataTable.$el.querySelector(
        ".el-table__body tbody"
      );
      const rows = table.children;
      const rowToAnimate = rows[index];
      if (rowToAnimate) {
        rowToAnimate.classList.add("animate-row");

        setTimeout(() => {
          rowToAnimate.classList.remove("animate-row");
        }, 1000);
      }
    },
    add() {
      this.addingUser = true;
      this.$store.dispatch("user/add", this.user).then((res) => {
        this.clear();
        this.$snackbar.add({
          type: "success",
          text: `Account added for ${res.data.name}`,
        });
        this.getUserList();
        this.addingUser = false;
      });
    },
    clear() {
      this.user = Object.assign({}, this.defaultUser);
      this.user.password.value = "";
      this.user.devices.forEach((device) => {
        (device.serial = ""), (device.address = "");
      });
      this.selectedUser = null;
    },
    handleEdit(idx, user) {
      this.resetModals();
      this.selectedUser = { ...user };
      this.selectedUser.idx = idx;
      // Name on edit modal should not change when it is being edited
      const { name } = this.selectedUser;
      this.name = name;
      this.modals.edit = true;
    },
    edit() {
      this.$store.dispatch("user/edit", this.selectedUser).then((res) => {
        this.$snackbar.add({
          type: "success",
          text: `Account updated for ${res.data.name}`,
        });
        this.getUserList();
        this.animateRow(this.selectedUser.idx);
        this.selectedUser = null;
        this.clear();
      });
    },
    handleResetPaswword(idx, user) {
      this.resetModals();
      this.modals.reset = true;
      this.selectedUser = { ...user };
      this.selectedUser.idx = idx;
    },
    validatePasswordReqs(newPassword) {
      const value = newPassword.trim();
      const symbols = "~`!@#$%^&*()-_+=<,>./?{[}]|\\";
      const charArr = Array.from(value);

      this.passwordReqs.forEach((req) => {
        req.validated = false;
      });

      let req = null;
      if (value.length >= Constants.MIN_PASSWORD_LEN) {
        req = this.passwordReqs.find((r) => r.name == "charLen");
        if (req) req.validated = true;
      }

      charArr.forEach((char) => {
        if (char.toUpperCase() === char && char.toLowerCase() !== char) {
          req = this.passwordReqs.find((r) => r.name == "uppercase");
          if (req) {
            req.validated = true;
          }
        } else if (char.toUpperCase() !== char && char.toLowerCase() === char) {
          req = this.passwordReqs.find((r) => r.name == "lowercase");
          if (req) {
            req.validated = true;
          }
        } else if (!isNaN(char)) {
          req = this.passwordReqs.find((r) => r.name == "digit");
          if (req) {
            req.validated = true;
          }
        } else if (symbols.includes(char)) {
          req = this.passwordReqs.find((r) => r.name == "special");
          if (req) {
            req.validated = true;
          }
        }
      });
    },
    resetModals() {
      this.modals = { add: false, edit: false, reset: false };
    },
    isPasswordReqsFulfilled() {
      return Object.values(this.passwordReqs).every((req) => req.validated);
    },
    reset() {
      // Check that all password requirements are met
      if (this.isPasswordReqsFulfilled()) {
        // Ready to reset password
        const obj = {
          udid: this.selectedUser.udid,
          new_password: this.resetPassword.value,
        };
        this.$store.dispatch("user/resetPassword", obj).then(() => {
          this.$snackbar.add({
            type: "success",
            text: `Password updated for ${this.selectedUser.name}`,
          });
          this.animateRow(this.selectedUser.idx);
          this.selectedUser = null;
          this.resetPassword.value = "";
        });
      }
    },
    togglePasswordVisibility(obj) {
      if (obj.fieldType == "password") {
        obj.fieldType = "text";
        obj.icon = "fa fas fa-eye-slash";
      } else {
        obj.fieldType = "password";
        obj.icon = "fa fas fa-eye";
      }
    },
    search() {
      this.page = 1;
      this.getUserList();
    },
    closeModal() {
    },
  },
};
</script>

<style scoped>
.separator {
  width: 1px;
  height: 50%;
  position: relative;
}
</style>
